import React, { Component } from 'react'
import { ResponsiveLine } from '@nivo/line'
import Aux from '../../../../../../hoc/Auxiliary/Auxiliary'
import { withTranslate } from 'react-redux-multilingual'
class LineChart extends Component {
  render() {
    let data = this.props.lineChart
    return (
      <Aux>
        <ResponsiveLine
          data={data}
          margin={{ top: 50, right: 50, bottom: 60, left: 60 }}
          xScale={{ type: 'point' }}
          yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: false, reverse: false }}
          // axisTop={null}
          // axisRight={null}
          // axisBottom={{
          //   orient: 'bottom',
          //   tickSize: 5,
          //   tickPadding: 5,
          //   tickRotation: 0,
          //   legend: 'transportation',
          //   legendOffset: 36,
          //   legendPosition: 'middle'
          // }}
          // axisLeft={{
          //   // tickValues: [20, 40, 60, 80, 100],
          //   orient: 'left',
          //   tickSize: 5,
          //   tickPadding: 5,
          //   tickRotation: 0,
          //   legend: 'count',
          //   legendOffset: -40,
          //   legendPosition: 'middle'
          // }}
          colors={{ scheme: 'nivo' }}
          dotSize={10}
          pointBorderWidth={2}
          pointBorderColor={{ from: 'serieColor' }}
          pointLabel='y'
          pointLabelYOffset={-12}
          useMesh={true}
          tooltip={({ point }) => {
            return (
              <div
                style={{
                  background: 'white',
                  padding: '9px 12px',
                  border: '1px solid #ccc',
                  borderRadius: '5px'
                }}>
                <div>
                  {this.props.translate('performance')}: {point.data.y}
                </div>
                <div>
                  {this.props.translate('year')}: {point.data.x}
                </div>
              </div>
            )
          }}
          theme={{
            tooltip: {
              container: {
                background: '#00000'
              }
            }
          }}
          legends={[
            {
              anchor: 'bottom',
              direction: 'row',
              justify: false,
              translateX: 0,
              translateY: 50,
              itemsSpacing: 0,
              itemDirection: 'left-to-right',
              itemWidth: 80,
              itemHeight: 20,
              itemOpacity: 0.75,
              symbolSize: 12,
              symbolShape: 'circle',
              symbolBorderColor: 'rgba(0, 0, 0, .5)',
              effects: [
                {
                  on: 'hover',
                  style: {
                    itemBackground: 'rgba(0, 0, 0, .03)',
                    itemOpacity: 1
                  }
                }
              ]
            }
          ]}
        />
      </Aux>
    )
  }
}

export default withTranslate(LineChart)
